{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Premašili ste ograničenje razgovora. Hacker plan dozvoljava samo 500 razgovora.",
      "INBOXES": "Premašili ste ograničenje prijemnih sandučića. Hacker plan podržava samo veb-sajt čat uživo. Dodatna sandučad poput e-pošte, WhatsApp-a itd. zahtevaju plaćeni plan.",
      "AGENTS": "Premašili ste ograničenje agenata. Hacker plan dozvoljava samo 2 agenta.",
      "NON_ADMIN": "Kontaktirajte vašeg administratora da nadogradi plan i nastavite da koristite sve funkcije."
    },
    "TITLE": "Podešavanja naloga",
    "SUBMIT": "Primeni izmene",
    "BACK": "Nazad",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Nije bilo moguće primeniti izmene, pokušajte ponovo!",
      "SUCCESS": "Izmene podešavanja naloga su uspešno primenjene"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Obrišite svoj nalog",
      "NOTE": "Kada obrišete svoj nalog, svi vaši podaci će biti obrisani.",
      "BUTTON_TEXT": "Obriši svoj nalog",
      "CONFIRM": {
        "TITLE": "Obriši nalog",
        "MESSAGE": "Brisanje naloga je nepovratno. Unesite naziv naloga ispod da potvrdite da želite trajno da ga obrišete.",
        "BUTTON_TEXT": "Obriši",
        "DISMISS": "Otkaži",
        "PLACE_HOLDER": "Unesite {accountName} da potvrdite"
      },
      "SUCCESS": "Nalog je označen za brisanje",
      "FAILURE": "Nije moguće obrisati nalog, pokušajte ponovo!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Ovaj nalog je zakazan za brisanje {deletionDate}. Ovo je zatražio administrator. Možete otkazati brisanje pre tog datuma.",
        "MESSAGE_INACTIVITY": "Ovaj nalog je zakazan za brisanje {deletionDate} zbog neaktivnosti naloga. Možete otkazati brisanje pre tog datuma.",
        "CLEAR_BUTTON": "Otkaži zakazano brisanje"
      }
    },
    "FORM": {
      "ERROR": "Molim vas ispravite greške formulara",
      "GENERAL_SECTION": {
        "TITLE": "Opšta podešavanja",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID naloga",
        "NOTE": "Ovaj ID je neophodan ako izgrađujete integraciju zasnovanu na API-ju"
      },
      "NAME": {
        "LABEL": "Naziv naloga",
        "PLACEHOLDER": "Naziv vašeg naloga",
        "ERROR": "Molim vas unesite ispravan naziv naloga"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Naziv vašeg naloga",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Domen dolazne e-pošte",
        "PLACEHOLDER": "Domen gde ćete primati e-poruke",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "E-pošta podrške",
        "PLACEHOLDER": "E-pošta podrške vaše kompanije",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Broj dana nakon čega će se tiket automatski rešiti ako nema aktivnosti",
        "NOTE": "Broj sati neaktivnosti nakon kojih će se svaki otvoreni razgovor automatski rešiti.",
        "PLACEHOLDER": "30",
        "ERROR": "Molim vas unesite ispravno trajanje za automatsko rešavanje (minimalno 1 dan i maksimalno 999 dana)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Broj dana nakon kojih će se prazan razgovor automatski rešiti ako nema aktivnosti",
        "PLACEHOLDER": "nikad",
        "ERROR": "Unesite ispravno trajanje za automatsko rešavanje praznih razgovora (minimalno 1 dan i maksimalno 999 dana)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Nastavljanje razgovora putem e-poruka je omogućeno za vaš nalog.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Sada možete da dobijate e-poruke u vaš prilagođeni domen."
      },
      "PHONE": {
        "TITLE": "PBX podešavanja",
        "NOTE": "Podesite vezu sa vašom PBX centralom za telefonske pozive",
        "SIP_HOST": {
          "LABEL": "SIP domen"
        },
        "DIALING_MODE": {
          "LABEL": "Režim pozivanja",
          "MODES": {
            "direct": "Direktno - poziv se odmah bira klikom na telefonsku vezu",
            "indirect": "Indirektno - broj telefona se priprema u polju za unos telefonskog vidžeta"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Pristup snimcima poziva",
          "MODES": {
            "admin_only": "Samo administratori",
            "admin_and_assigned_agent": "Administratori i dodeljeni agent",
            "inbox_members": "Svi agenti sa pristupom sandučetu"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Podešavanja e-pošte",
        "NOTE": "Menja ponašanje sandučića e-pošte"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Režim prikaza vremenske oznake razgovora",
        "MODES": {
          "both": "Napravljeno i poslednja aktivnost",
          "last_activity_only": "Samo poslednja aktivnost",
          "last_customer_message": "Poslednja poruka klijenta"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blokiraj domene sa niskom reputacijom"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Uključi originalnu poruku u odgovor na e-poštu"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Automatski reši novi razgovor"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Automatski premesti novi razgovor e-poštom u prijemno sanduče robota koji je obradio porudžbine kontakta"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Proširene oznake - Dozvoli duže nazive oznaka sa većim iskačućim prozorom"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Automatski dodeli razgovor agentu koji je poslao poslednji odgovor"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Režim push obaveštenja",
        "MODES": {
          "all_inboxes": "Sva sandučad - Šalji obaveštenja za sve tipove kanala",
          "chat_only": "Samo ćaskanje - Šalji obaveštenja samo za kanale koji nisu e-pošta"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Dozvoli uključivanje/isključivanje potpisa u poslatim porukama"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Prikaži status ćaskanja agenta na wallboard-u"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Prikaži pune nazive priloga bez skraćivanja"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Prijava lozinkom",
        "MODES": {
          "allowed_for_all": "Dozvoljeno svim korisnicima",
          "allowed_for_agents_only": "Dozvoljeno samo agentima (administratori moraju koristiti OAuth)",
          "password_login_disabled": "Onemogućeno - samo OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Dostupna je nova verzija. Osvežite stranicu da biste dobili najnovija ažuriranja.",
    "RELOAD_NOW": "Ažuriraj sada",
    "LEARN_MORE": "Saznajte više",
    "PAYMENT_PENDING": "Vaše plaćanje je na čekanju. Ažurirajte podatke o plaćanju da biste nastavili da koristite kontakt centar",
    "LIMITS_UPGRADE": "Vaš nalog je premašio ograničenja korišćenja. Nadogradite svoj plan da biste nastavili da koristite kontakt centar",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Pritisnite enter da bi ste izabrali",
      "ENTER_TO_REMOVE": "Pritisnite enter da bi ste uklonili",
      "NO_OPTIONS": "Lista je prazna",
      "NO_RESULT": "Nema rezultata",
      "SELECT_ONE": "Izaberite jedno",
      "SELECT": "Izaberi"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Obaveštenja",
    "MARK_ALL_DONE": "Označi sve kao završeno",
    "DELETE_TITLE": "obrisano",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Nepročitana obaveštenja",
      "ALL_NOTIFICATIONS": "Pregledaj sva obaveštenja",
      "LOADING_UNREAD_MESSAGE": "Učitavanje nepročitanih obaveštenja...",
      "EMPTY_MESSAGE": "Nemate nepročitanih obaveštenja"
    },
    "LIST": {
      "LOADING_MESSAGE": "Učitavanje obaveštenja...",
      "404": "Nema obaveštenja",
      "TABLE_HEADER": [
        "Ime",
        "Broj telefona",
        "Razgovori",
        "Poslednji put kontaktiran"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Novi razgovor",
      "conversation_assignment": "Dodeljen razgovoru",
      "assigned_conversation_new_message": "Nova poruka",
      "participating_conversation_new_message": "Nova poruka",
      "conversation_mention": "Pominjanje",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Nedostupan",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Osveži"
    },
    "CONNECTION_LOST": {
      "TITLE": "Веза је прекинута",
      "DESCRIPTION": "Нисмо могли да се повежемо са сервером. Проверите везу и покушајте поново.",
      "RETRY": "Покушај поново"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Pretraži ili idi na",
    "SECTIONS": {
      "GENERAL": "Opšta",
      "REPORTS": "Izveštaji",
      "CONVERSATION": "Razgovor",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Promeni dodeljenog",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Promeni tim",
      "SNOOZE_CONVERSATION": "Odloži razgovor",
      "EXECUTE_MACRO": "Izvrši makro",
      "ADD_LABEL": "Dodaj oznaku razgovoru",
      "REMOVE_LABEL": "Ukloni oznaku sa razgovora",
      "SETTINGS": "Podešavanja",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Idi na radnu tablu razgovora",
      "GO_TO_CONTACTS_DASHBOARD": "Idi na radnu tablu kontakata",
      "GO_TO_REPORTS_OVERVIEW": "Idi na pregled izveštaja",
      "GO_TO_CONVERSATION_REPORTS": "Idi na izveštaje o razgovorima",
      "GO_TO_AGENT_REPORTS": "Idi na izveštaje o agentima",
      "GO_TO_LABEL_REPORTS": "Idi na izveštaje o oznakama",
      "GO_TO_INBOX_REPORTS": "Idi na izveštaje o prijamnim sandučićima",
      "GO_TO_TEAM_REPORTS": "Idi na izveštaje o timovima",
      "GO_TO_SETTINGS_AGENTS": "Idi na podešavanja agenata",
      "GO_TO_SETTINGS_TEAMS": "Idi na podešavanja timova",
      "GO_TO_SETTINGS_INBOXES": "Idi na podešavanja prijemnih sandučića",
      "GO_TO_SETTINGS_LABELS": "Idi na podešavanja oznaka",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Idi na podešavanja brzih odgovora",
      "GO_TO_SETTINGS_APPLICATIONS": "Idi na podešavanja aplikacije",
      "GO_TO_SETTINGS_ACCOUNT": "Idi na podešavanja naloga",
      "GO_TO_SETTINGS_PROFILE": "Idi na podešavanja profila",
      "GO_TO_NOTIFICATIONS": "Idi na obaveštenja",
      "ADD_LABELS_TO_CONVERSATION": "Dodaj oznaku razgovoru",
      "ASSIGN_AN_AGENT": "Dodeli agenta",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Dodeli tim",
      "EXECUTE_A_MACRO": "Izvrši makro",
      "MUTE_CONVERSATION": "Utišaj razgovor",
      "UNMUTE_CONVERSATION": "Poništi utišanje razgovora",
      "REMOVE_LABEL_FROM_CONVERSATION": "Ukloni oznaku sa razgovora",
      "REOPEN_CONVERSATION": "Ponovo otvori razgovor",
      "RESOLVE_CONVERSATION": "Reši razgovor",
      "SEND_TRANSCRIPT": "Pošalji transkript e-poštom",
      "SNOOZE_CONVERSATION": "Odloži razgovor",
      "UNTIL_NEXT_REPLY": "Do sledećeg odgovora",
      "UNTIL_NEXT_WEEK": "Do sledeće nedelje",
      "UNTIL_TOMORROW": "Do sutra",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "kliknite ovde"
  }
}
